import { FunctionComponent, useCallback } from 'react'

import { useLinkTo } from '@react-navigation/native'
import { Product } from 'integration/resources/products'
import { ProductCardSearchDesktop } from 'molecules/ProductCardSearch/ProductCardSearchDesktop'
import { Box, FlatList, Link } from 'native-base'

type Props = {
  products: Product[]
}

export const ProductListSearch: FunctionComponent<Props> = ({ products }) => {
  const linkTo = useLinkTo()

  const numColumns = 2

  const keyExtractor = useCallback((item: { id: number | string }) => `key-${item.id}`, [])

  return (
    <FlatList
      w="full"
      h="full"
      data={products}
      keyExtractor={keyExtractor}
      key={`flatlist-products-${Math.random()}`}
      renderItem={({ item, index }) => (
        <Box mx={2} mb={6}>
          <Link onPress={() => linkTo(`/produto/${item.slug}`)}>
            <ProductCardSearchDesktop product={item} />
          </Link>
        </Box>
      )}
      showsHorizontalScrollIndicator
      showsVerticalScrollIndicator
      numColumns={numColumns}
    />
  )
}
